import React, { ReactElement } from 'react';
import { GetStaticPaths, GetStaticProps } from 'next';
import utils from '../../utils';
import buildHelpers from '../../utils/buildHelpers';
import WithPage from '../../HOC/Page/WithPage';
import { ISkillbuilderProps as PageTypeSkillBuilder } from '../../models/SkillBuilder/@types';
import MainLayout from '../../layout/MainLayout';
import { getAllContentEntries, getPageData } from '../../models/Contentful';
import { IStaticPageProps } from '../../models/Contentful/types';
import { LayoutPage } from '../../types/page';
import SkillBuilderDetail from '../../components/SkillBuilderDetail';

const SkillBuilderDetailPage: LayoutPage<IStaticPageProps<PageTypeSkillBuilder>> = ({ page }) => {
  return <SkillBuilderDetail {...(page as PageTypeSkillBuilder)} />;
};

SkillBuilderDetailPage.getLayout = function getLayout(
  page: ReactElement,
  props: IStaticPageProps<PageTypeSkillBuilder>,
) {
  return <MainLayout {...props}>{page}</MainLayout>;
};

export const getStaticPaths: GetStaticPaths = async () => {
  const SkillBuilderData = await getAllContentEntries({
    content_type: 'skillbuilder',
  });

  let SkillBuilderSlugs = SkillBuilderData.items.map(data => ({
    params: { slug: [data.fields.slug] },
  }));

  const { shouldBuildClean, entrySlugs } =
    await buildHelpers.getContentEntriesSlug<PageTypeSkillBuilder>(
      {
        content_type: 'skillbuilder',
      },
      {
        contentType: 'skillbuilder',
      },
    );

  SkillBuilderSlugs = utils.filterUndefinedSlugs(SkillBuilderSlugs);

  buildHelpers.writePagesMeta(
    SkillBuilderData.items.map(skillBuilder => ({
      fields: {
        slug: `skillbuilders/${skillBuilder.fields.slug}`,
        directory: '',
        entryId: skillBuilder.sys?.id ?? 'skillbuilder',
        seoMetadata: skillBuilder.fields?.seoMetadata,
      },
      sys: skillBuilder.sys,
    })),
  );
  return {
    paths: shouldBuildClean ? SkillBuilderSlugs : entrySlugs || SkillBuilderSlugs,
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps<IStaticPageProps<PageTypeSkillBuilder>> = async ({
  params,
}) => {
  const slug = params?.slug || [''];
  const pageResponse = await getPageData<PageTypeSkillBuilder>(slug[0], 'skillbuilder');
  const res = { ...pageResponse, key: slug[slug.length - 1] };
  return { props: res };
};

export default WithPage(SkillBuilderDetailPage);
